
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BillingPlanDtoModel } from './Accounting.Api.Models.BillingPlanDto';
import { Model, ModelProperty } from 'models/Model';


export class CreditWizardRequestModel extends Model<CreditWizardRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'creditWizardRequest.property.companyId' },
		{ name: 'noHandlingFees', type: 'boolean', languageString: 'creditWizardRequest.property.noHandlingFees' },
		{ name: 'invoiceNo', type: 'string', languageString: 'creditWizardRequest.property.invoiceNo' },
		{ name: 'brandId', type: 'guid', languageString: 'creditWizardRequest.property.brandId' },
		{ name: 'credits', type: 'CreditDtoModel[]', languageString: 'creditWizardRequest.property.credits', isHidden: true, isArray: true, isObject: true, new: () => { return new CreditDtoModel }, properties: () => { return CreditDtoModel.classProperties } },
		{ name: 'endAccountingPlans', type: 'EndAccountingPlanDtoModel[]', languageString: 'creditWizardRequest.property.endAccountingPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new EndAccountingPlanDtoModel }, properties: () => { return EndAccountingPlanDtoModel.classProperties } },
		{ name: 'billingPlans', type: 'BillingPlanDtoModel[]', languageString: 'creditWizardRequest.property.billingPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new BillingPlanDtoModel }, properties: () => { return BillingPlanDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public companyId?: string;
	public noHandlingFees?: boolean;
	public invoiceNo: string;
	public brandId?: string;
	public credits: CreditDtoModel[];
	public endAccountingPlans: EndAccountingPlanDtoModel[];
	public billingPlans: BillingPlanDtoModel[];
    
	constructor(){
		super();
		this.companyId = undefined;
		this.noHandlingFees = undefined;
		this.invoiceNo = '';
		this.brandId = undefined;
		this.credits = [];
		this.endAccountingPlans = [];
		this.billingPlans = [];
		
	}
	getProperties(){
		return CreditWizardRequestModel.classProperties;
	}
}
export class CreditDtoModel extends Model<CreditDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'invoiceLineNumber', type: 'number', languageString: 'creditDto.property.invoiceLineNumber' },
		{ name: 'accountingPlanId', type: 'guid', languageString: 'creditDto.property.accountingPlanId' },
		{ name: 'amount', type: 'number', languageString: 'creditDto.property.amount' }
	];
	[key: string]: any;
	
	public invoiceLineNumber: number;
	public accountingPlanId?: string;
	public amount: number;
    
	constructor(){
		super();
		this.invoiceLineNumber = 0;
		this.accountingPlanId = undefined;
		this.amount = 0;
		
	}
	getProperties(){
		return CreditDtoModel.classProperties;
	}
}
export class EndAccountingPlanDtoModel extends Model<EndAccountingPlanDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'guid', languageString: 'endAccountingPlanDto.property.accountingPlanId' },
		{ name: 'endDate', type: 'Date', languageString: 'endAccountingPlanDto.property.endDate' },
		{ name: 'terminationDate', type: 'Date', languageString: 'endAccountingPlanDto.property.terminationDate' },
		{ name: 'terminationReasonId', type: 'guid', languageString: 'endAccountingPlanDto.property.terminationReasonId' },
		{ name: 'removeAllUnpostedInvoicePosts', type: 'boolean', languageString: 'endAccountingPlanDto.property.removeAllUnpostedInvoicePosts' },
		{ name: 'createRenewal', type: 'boolean', languageString: 'endAccountingPlanDto.property.createRenewal' },
		{ name: 'nextPeriod', type: 'number', languageString: 'endAccountingPlanDto.property.nextPeriod' }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public endDate?: Date;
	public terminationDate?: Date;
	public terminationReasonId?: string;
	public removeAllUnpostedInvoicePosts?: boolean;
	public createRenewal: boolean;
	public nextPeriod: number;
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.endDate = undefined;
		this.terminationDate = undefined;
		this.terminationReasonId = undefined;
		this.removeAllUnpostedInvoicePosts = undefined;
		this.createRenewal = false;
		this.nextPeriod = 0;
		
	}
	getProperties(){
		return EndAccountingPlanDtoModel.classProperties;
	}
}

